import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { AudiPlatformProvider, Select } from '@audi/audi-ui-react';
import React from 'react';
import ReactDOM from 'react-dom';

@Component({
    selector: 'app-audi-select',
    template: ''
})
export class AudiSelectComponent implements AfterViewInit, OnChanges, OnDestroy {
    //https://react.ui.audi/?path=/story/components-select-overview--page
    @Input() inputId = '';
    @Input() label = '';
    @Input() value: any;
    @Input() options: any[];
    @Input() isRequired = 'false';
    @Output() valueChange = new EventEmitter<string>();

    ElementToShow = () => (
        <AudiPlatformProvider>
            <Select
                inputId={this.inputId}
                label={this.label}
                required={this.isRequired == 'true'}
                value={this.value}
                onChange={this.handleChange}>
                {this.options && this.options.map((option: any) =>
                    <option key={option.value} value={option.value}>{option.label}</option>
                )}
            </Select>
        </AudiPlatformProvider>
    );

    constructor(private hostRef: ElementRef) {
        this.handleChange = this.handleChange.bind(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        //console.log('select ngOnChanges: ' + this.hostRef.nativeElement);
        this.render();
    }

    ngAfterViewInit(): void {
        //console.log('ngAfterViewInit');
        this.render();
    }

    ngOnDestroy(): void {
        //console.log('ngOnDestroy');
        ReactDOM.unmountComponentAtNode(this.hostRef.nativeElement);
    }

    private render() {
        //console.log('select rendering');
        ReactDOM.render(<this.ElementToShow />, this.hostRef.nativeElement);
    }

    public handleChange(event: any): void {
        this.value = event.target.value;
        //console.log('select handleChange: ' + this.value);
        this.valueChange.emit(this.value);
        this.render();
    }
}
